import { useState } from "react";
import { Box, Link, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { EraseDataDialog } from "./EraseDataDialog";

const PRIVACY_URL = "https://cloud.pinehood.tech/privacy/";
const TERMS_URL = "https://cloud.pinehood.tech/terms/";

export function PageFooter() {
  const { t } = useTranslation();
  const [eraseOpen, setEraseOpen] = useState(false);

  return (
    <>
      <Box
        sx={{
          mt: 6,
          pt: 4,
          borderTop: "1px solid",
          borderColor: "divider",
          pb: 4,
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "flex-start", sm: "center" },
          justifyContent: "space-between",
          gap: 1,
        }}
      >
        <Typography
          variant="caption"
          sx={{
            color: "text.secondary",
          }}
        >
          &copy; {new Date().getFullYear()} {t("footer.copyright")}
        </Typography>
        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
          <Link
            component="button"
            type="button"
            onClick={() => setEraseOpen(true)}
            variant="caption"
            sx={{
              color: "text.secondary",
              cursor: "pointer",
              border: 0,
              background: "none",
              p: 0,
            }}
          >
            {t("erase.link")}
          </Link>
          <Link
            href={TERMS_URL}
            target="_blank"
            rel="noopener noreferrer"
            variant="caption"
            sx={{
              color: "text.secondary",
            }}
          >
            {t("footer.terms")}
          </Link>
          <Link
            href={PRIVACY_URL}
            target="_blank"
            rel="noopener noreferrer"
            variant="caption"
            sx={{
              color: "text.secondary",
            }}
          >
            {t("footer.privacy")}
          </Link>
        </Box>
      </Box>
      <EraseDataDialog open={eraseOpen} onClose={() => setEraseOpen(false)} />
    </>
  );
}
